{
  "searchTypeahead": "Search for CMS data",
  "searchTypeaheadMobile": "Search for CMS data"
}
